export default "__VITE_ASSET___ZZkOkss__"